module.exports = __webpack_public_path__ + "img/premium_feature_02.955e3ee6.jpg";